import { useEffect } from "react";
import { useCookieConsent } from "../../context/CookieContext";

const HeadScript = () => {
  const { consent } = useCookieConsent();

  useEffect(() => {
    if (consent && consent.analytics) {
      // Create script element
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.async = true;
      script.innerHTML = `
        (function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "r7fj7exqm9");
      `;

      // Add script to head
      document.head.appendChild(script);

      // Cleanup function
      return () => {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      };
    }
  }, [consent]);

  return null;
};

export default HeadScript;
